import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const SipCall = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M20 8.64357V4H15.3591M20 4L14.3278 9.67548M8.6156 4.74074L9.5102 7.78417C9.61882 8.1537 9.51272 8.55299 9.23502 8.81974L8.29245 9.72514C7.96657 10.0382 7.87875 10.5291 8.10345 10.9212C9.29022 12.9921 11.0132 14.716 13.0828 15.9035C13.4747 16.1283 13.9654 16.0405 14.2782 15.7144L15.1831 14.7713C15.4497 14.4934 15.8487 14.3873 16.218 14.4959L19.2597 15.3911C19.6986 15.5202 20 15.9233 20 16.381V19.9945C20 20.5644 19.5379 21.0295 18.9692 20.9985C16.2885 20.8527 13.6863 20.1319 11.3443 18.7724C8.81452 17.3038 6.70401 15.192 5.23629 12.6608C3.8877 10.335 3.1234 7.69723 3.00102 5.01621C2.97531 4.45296 3.43783 4 4.00134 4H7.6262C8.0837 4 8.48651 4.30158 8.6156 4.74074Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          d='M4.2225 3.5C3.27826 3.5 2.45598 4.26707 2.50183 5.27152C2.62602 7.99225 3.40148 10.6698 4.77172 13.0329C6.26172 15.6025 8.40391 17.7458 10.9721 19.2367C13.3558 20.6204 15.9981 21.35 18.7079 21.4974C19.7169 21.5523 20.4997 20.7293 20.4997 19.7731V16.2663C20.4997 15.4889 19.9878 14.8044 19.2424 14.5851L16.2905 13.7164C15.6633 13.5318 14.9855 13.7121 14.5328 14.184L13.6546 15.0993C13.5717 15.1857 13.4689 15.1855 13.4094 15.1514C11.5164 14.0653 9.94021 12.4882 8.85476 10.5942C8.82067 10.5347 8.82048 10.4318 8.90683 10.3489L9.82159 9.47023C10.2932 9.01722 10.4734 8.33909 10.289 7.71152L9.42075 4.75799C9.20151 4.01217 8.51739 3.5 7.7404 3.5H4.2225Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.4948 4.25107C14.4948 3.83626 14.8309 3.5 15.2454 3.5H19.7493C20.1639 3.5 20.5 3.83626 20.5 4.25107V8.75746C20.5 9.17226 20.1639 9.50852 19.7493 9.50852C19.3348 9.50852 18.9987 9.17226 18.9987 8.75746V6.0643L14.7754 10.29C14.4822 10.5833 14.0069 10.5833 13.7138 10.29C13.4206 9.99665 13.4206 9.5211 13.7138 9.2278L17.9371 5.00213H15.2454C14.8309 5.00213 14.4948 4.66587 14.4948 4.25107Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
